import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

    handleError(error: Error) {
        // your custom error handling logic
        console.log("this is my custom error", error)
        let temp = error.stack
        throw new Error(temp);
    }
}